{
  "menu": {
    "about": "Over Ons",
    "facilities": "Faciliteiten",
    "villas": "Villa's & Tarieven",
    "allRooms": "Alle Kamers",
    "experiences": "Dingen om te Doen",
    "gallery": "Galerij",
    "news": "Nieuws",
    "contact": "Contact",
    "dining": "Dineren",
    "spa": "Spa"
  },
  "cta": {
    "book": "Boek Nu",
    "contact": "Neem Contact Op",
    "back_to_home": "Terug naar Home",
    "read_more": "Lees Meer"
  },
  "home": {
    "culture": {
      "subtitle": "Authentiek Balinees Erfgoed",
      "title": "Culturele Ervaringen",
      "desc": "Dompel uzelf onder in het rijke spirituele en culturele erfgoed van Bali. Van heilige waterreinigingsrituelen tot het verkennen van eeuwenoude tradities, wij begeleiden u op een reis om de ware ziel van het eiland te ontdekken.",
      "journeySub": "Spirituele Reis",
      "journeyTitle": "Sidemen Zuivering",
      "journeyDesc": "Ervaar een traditioneel Balinees waterreinigingsritueel (Melukat) in de heilige bronnen van Sidemen, ontworpen om uw lichaam, geest en ziel te reinigen.",
      "btnReserve": "Reservering"
    },
    "activities": {
      "subtitle": "Geselecteerde Momenten",
      "title": "Dingen om te Doen",
      "desc": "Wij bieden de beste, speciaal voor u geselecteerde activiteiten om onvergetelijke herinneringen te creëren tijdens uw verblijf. Dompel uzelf onder in de magie van Bali, van spannende avonturen tot diepgaande culturele verkenningen en spiritueel welzijn.",
      "btnView": "Bekijk Activiteiten",
      "btnReserve": "Reservering"
    },
    "different": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Wat Ons Anders Maakt",
      "desc": "Ontdek de ware essentie van een verborgen juweeltje. Ver weg van de drukte bieden wij een afgelegen toevluchtsoord waar elk detail is ontworpen om u te helpen ontkoppelen, opladen en vertrekken met prachtige herinneringen die een leven lang meegaan.",
      "card1": {
        "sub": "Een privé toevluchtsoord ver weg van de wereld",
        "title": "De Verborgen Parel van Sidemen",
        "desc": "Verborgen ver van de drukke straten, biedt onze villa de ultieme exclusiviteit en privacy. Hier bent u niet zomaar een gast, maar een bevoorrechte reiziger die de ongerepte sereniteit van het authentieke Bali ervaart."
      },
      "card2": {
        "sub": "Ontwaak uw zintuigen en laad uw ziel op",
        "title": "Vernieuwde Energie",
        "desc": "Adem de frisse lucht in van onze weelderige tropische tuinen en uitgestrekte rijstvelden. Elk moment in onze vredige omgeving is ontworpen om uw geest, lichaam en ziel te verjongen."
      },
      "card3": {
        "sub": "Momenten die u voor altijd zult koesteren",
        "title": "Prachtige Herinneringen",
        "desc": "Van oprechte glimlachen tot authentieke lokale ervaringen, wij creëren elk detail van uw verblijf met oprechte zorg. Keer niet alleen uitgerust huiswaarts, maar met prachtige, onvergetelijke verhalen om te vertellen."
      }
    },
    "booking": {
      "title": "Klaar om Patal Kikian te Ervaren?",
      "desc": "Controleer de beschikbaarheid en verzeker u vandaag nog van uw privé toevluchtsoord."
    },
    "contact": {
      "subtitle": "Contact",
      "title": "Hoe u ons kunt bereiken",
      "desc": "Of u nu een vraag heeft over onze kamers, hulp nodig heeft bij uw boeking of een speciaal verzoek heeft voor uw aanstaande verblijf, ons toegewijde conciërgeteam staat klaar om u te helpen.",
      "btnEmail": "Stuur een E-mail",
      "btnWa": "WhatsApp Ons"
    },
    "hero": {
      "subtitle": "Welkom bij Patal Kikian Villas",
      "title": "Ontwaak met Bali's Meest Adembenemende Panorama",
      "description": "Omarm de majestueuze aanwezigheid van de berg Agung terwijl deze waakt over smaragdgroene rijstterrassen en weelderige, glooiende valleien. Hier in de vredige omhelzing van Sidemen, weven de frisse berglucht en ongerepte sereniteit zich samen om een onvergetelijk toevluchtsoord voor je ziel te creëren."
    },
    "intro": {
      "quote": "\"Al tientallen jaren inspireert de fascinerende schoonheid van Sidemen de wereld.\"",
      "p1": "In 1938 vereeuwigde de legendarische kunstenaar Walter Spies de betoverende charme van deze regio in zijn meesterwerk, <span className=\"italic text-white\">\"Morning in Iseh.\"</span> Het schilderij legde op prachtige wijze de torenhoge majesteit van de berg Agung, de weelderige smaragdgroene rijstterrassen, de zachte ochtendmist en het vredige ritme van het landelijke Balinese leven vast. Tot op de dag van vandaag blijft het een iconisch symbool van Bali's natuurlijke pracht.",
      "p2": "Vandaag de dag ontvouwt ditzelfde adembenemende panorama zich recht voor uw ogen bij Patal Kikian Villas.",
      "p3": "Elke ochtend brengt een spectaculaire zonsopgang die de berg Agung in een gouden licht baadt, weidse groene valleien verlicht en een frisse bries uit de bergen brengt. Hier heerst rust, waardoor het lijkt alsof de tijd is vertraagd.",
      "p4": "Bij Patal Kikian verblijft u niet zomaar in een luxe villa; u dompelt uzelf onder in precies hetzelfde landschap dat kunstenaars, fotografen en natuurliefhebbers uit alle hoeken van de wereld heeft gefascineerd.",
      "p5": "Wij bieden een feilloze harmonie van verfijnde luxe, diep cultureel erfgoed en de authentieke natuurlijke schoonheid van Sidemen.",
      "footerQuote": "Kom voor een vakantie. Vertrek met herinneringen waarnaar u voor altijd zult verlangen.",
      "footerBrand": "Patal Kikian Villas",
      "footerTagline": "Waar Elke Zonsopgang Een Meesterwerk Wordt"
    },
    "restaurant": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Patal Kikian Restaurant",
      "desc": "Gelegen naast onze infinity pool en elegante bar, biedt ons restaurant een opmerkelijke dinerervaring omlijst door een weids uitzicht op de groene valleien en uitgestrekte rijstvelden. Geniet van voortreffelijke culinaire creaties terwijl het zachte briesje en de adembenemende natuurlijke omgeving uw zintuigen prikkelen.",
      "callToAction": "Ontdek onze voortreffelijke culinaire aanbiedingen. Ontdek onze lokale en internationale specialiteiten door ons menu te bekijken, of reserveer uw tafel voor een onvergetelijke dinerervaring.",
      "btnMenu": "Bekijk Menu",
      "btnReserve": "Reservering",
      "btnTransport": "Reservering Speciaal Vervoer",
      "btnTransportSub": "(Sidemen Regio)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Locatie"
    },
    "spa": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Patal Kikian Spa",
      "desc": "Verjong uw geest, lichaam en ziel in Patal Kikian Spa. Ervaar authentieke Balinese genezingsrituelen en ontspannende massages, uitgevoerd door onze bekwame therapeuten, terwijl u geniet van de adembenemende natuurlijke schoonheid van Sidemen.",
      "callToAction": "Ontdek ons volledige aanbod aan holistische behandelingen. Bekijk ons spa-menu om onze ontspannende therapieën te ontdekken, of boek vandaag nog uw verjongingssessie.",
      "btnMenu": "Bekijk Menu",
      "btnReserve": "Reservering",
      "btnTransport": "Reservering Speciaal Vervoer",
      "btnTransportSub": "(Sidemen Regio)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Locatie"
    },
    "rooms": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Patal Kikian Villas",
      "desc": "Elke villa is zorgvuldig ontworpen als uw privé toevluchtsoord, met adembenemende, ononderbroken uitzichten op de berg Agung, uitgestrekte rijstvelden en weelderige groene valleien, waarbij luxe naadloos overgaat in de rust van de natuur."
    }
  },
  "about": {
    "hero": {
      "subtitle": "Ons Verhaal",
      "title": "Ontwaak met Bali's Meest Adembenemende Panorama",
      "desc": "Omarm de majestueuze aanwezigheid van Mount Agung die waakt over smaragdgroene rijstterrassen en weelderige valleien. Hier in de vredige omhelzing van Sidemen, weven frisse berglucht en ongerepte rust samen om een onvergetelijk toevluchtsoord te creëren.",
      "btnScroll": "Lees Verhaal"
    },
    "story": {
      "p1": "Genesteld aan de rand van Sidemen, Karangasem, is Patal Kikian Villas meer dan alleen een bestemming; het is een uitnodiging om het hart van Bali te ervaren. Met een panoramisch uitzicht vanaf de top van de heuvel, begint elke ochtend hier met een symfonie van de natuur: een gouden zonsopgang die de torenhoge top van Mount Agung verlicht, omlijst door eindeloos groen en ongerepte landschappen.",
      "p2": "Wij geloven dat ware luxe ligt in harmonie met de natuur. Als u ons heiligdom binnenstapt, wordt u omhuld door de frisse, zuivere berglucht en een diep gevoel van rust. Het is een plek die ontworpen is om u los te koppelen van het lawaai van de wereld en u opnieuw te verbinden met wat er echt toe doet.",
      "subtitle": "Een Harmonie van Natuur en Cultuur",
      "p3": "Onze villa's weerspiegelen een naadloze mix van traditionele Balinese architectuur en modern comfort, zorgvuldig ontworpen om de rijke cultuur van Sidemen te eren. Wij zijn trots op onze warme, authentieke gastvrijheid. Hier is elke glimlach oprecht, en wordt elke service verleend met het diepste respect voor zowel onze gasten als ons lokaal erfgoed.",
      "quote": "\"Patal Kikian Villas is uw verborgen paradijs - een plek waar majestueuze landschappen, rijke cultuur en oprechte gastvrijheid een onvergetelijk tapijt van herinneringen weven.\"",
      "footer": "We kijken ernaar uit om u te verwelkomen in ons toevluchtsoord."
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "Resort Voorzieningen",
      "title": "Onze Faciliteiten",
      "desc": "Ontdek onze premium voorzieningen die zijn ontworpen om u comfort en ontspanning te bieden tijdens uw verblijf in Sidemen.",
      "btnScroll": "Bekijk Faciliteiten"
    },
    "fallback": {
      "poolSub": "Oase van Rust",
      "poolTitle": "Zwembaden",
      "poolDesc1": "Dompel uzelf onder in onze kristalheldere infinity pools met uitzicht op de tropische tuinen en de weelderige vallei. Of u nu geniet van een ochtendduik, een drijvend ontbijt, of gewoon heerlijk in de zon ligt met een verfrissende cocktail, onze zwembaden bieden de ultieme ruimte voor ontspanning.",
      "poolDesc2": "In geselecteerde villa's zijn ook privé dompelbaden beschikbaar voor wie op zoek is naar een intiem toevluchtsoord.",
      "restSub": "Culinaire Uitmuntendheid",
      "restTitle": "Restaurant",
      "restDesc1": "Geniet van een gastronomische reis in ons karakteristieke open-air restaurant. We zijn er trots op dat we authentieke Balinese gerechten serveren naast internationale favorieten, allemaal bereid met de meest verse, lokaal geproduceerde biologische ingrediënten.",
      "restDesc2": "Geniet van uw gratis ontbijt, romantische diners bij kaarslicht of ontspannen afternoon tea's terwijl u het adembenemende uitzicht op de omliggende natuur in u opneemt.",
      "restBtn": "Bekijk Meer",
      "spaSub": "Welzijn en Genezing",
      "spaTitle": "Luxe Spa",
      "spaDesc1": "Verjong uw geest, lichaam en ziel in ons rustige spa-heiligdom. Geworteld in eeuwenoude Balinese genezingstradities, bieden onze professionele therapeuten een scala aan behandelingen, van traditionele massages tot revitaliserende lichaamsscrubs en gezichtsbehandelingen.",
      "spaDesc2": "Als onze gast ontvangt u ook een gratis voetmassage van 15 minuten bij aankomst, zodat de vermoeidheid van uw reis onmiddellijk verdwijnt.",
      "spaBtn": "Bekijk Meer"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "Onze Kamers",
      "title": "Heiligdommen van Rust bij Patal Kikian Villas",
      "desc": "Ervaar ultieme rust in onze prachtig ontworpen villa's, waar modern comfort samensmelt met Balinese authenticiteit.",
      "btnScroll": "Ontdek de Kamers"
    },
    "detail": {
      "loading": "Kamerdetails laden...",
      "signature": "Signature Kamer",
      "gallerySub": "Galerij",
      "galleryTitle": "Kamer Fotogalerij",
      "noImages": "Geen afbeeldingen beschikbaar voor dit kamertype.",
      "aboutRoom": "Over de Kamer",
      "roomSize": "Kamergrootte",
      "bedSize": "Bedgrootte",
      "view": "Uitzicht",
      "amenities": "Voorzieningen",
      "inclusions": "Inclusief",
      "pleaseNote": "Let op",
      "roomRules": "Huisregels & Informatie",
      "roomPolicy": "Kamerbeleid",
      "childrenPolicies": "Kinderbeleid",
      "childrenPolicyDesc": "Kinderen van alle leeftijden zijn toegestaan. Kinderen tot en met 5 jaar verblijven gratis. Kinderen van 6 tot en met 12 jaar kunnen verblijven voor IDR 151.250,00 per kind per nacht in een extra bed.",
      "babyCot": "Babybedje",
      "babyCotDesc": "Kinderen tot en met 2 jaar verblijven gratis bij gebruik van een beschikbaar babybedje.",
      "extraBed": "Extra bed",
      "extraBedDesc": "Personen van elke leeftijd verblijven voor IDR 302.500,00 per persoon per nacht bij gebruik van een beschikbaar extra bed.",
      "noSmoking": "Roken is niet toegestaan.",
      "noPets": "Huisdieren zijn niet toegestaan.",
      "reserve": "Reserveren",
      "directBooking": "Direct bij ons Boeken",
      "bookOnBooking": "Boek op Booking.com",
      "contactConcierge": "Neem contact op met onze conciërge voor vragen over reserveringen en speciale verzoeken.",
      "otherChoices": "Andere Keuzes",
      "otherRooms": "Andere kamers die u misschien leuk vindt",
      "bookYourStay": "Boek Uw Verblijf"
    }
  },
  "luxuryCard": {
    "discover": "Ontdekken"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "Deluxe Bungalow (Bergzicht)",
      "description": "Deze bungalow beschikt over een overloopzwembad. Deze bungalow met airconditioning heeft een eigen ingang en bestaat uit 1 woonkamer, 1 aparte slaapkamer en 1 badkamer met een douche en een haardroger. De bungalow is ingericht met een bureau en een zithoek en beschikt over een minibar, een thee- en koffiezetapparaat en uitzicht op de tuin. De unit heeft 1 bed.",
      "view": "Uitzicht op tuin, zwembad, bergen, bezienswaardigheid & rivier",
      "roomRules": "Roken: Niet roken. Stilte na 22:00 uur. Inchecken om 14:00 uur, Uitchecken om 12:00 uur."
    },
    "suite-room-mountain-view": {
      "title": "Suite Kamer (Bergzicht)",
      "description": "Gasten zullen een bijzondere ervaring hebben, want deze suite biedt een zwembad met uitzicht. Deze ruime suite heeft een eigen ingang en bestaat tevens uit 1 slaapkamer, een zithoek en 1 badkamer met een douche en een haardroger. De accommodatie is voorzien van airconditioning, uitzicht op de tuin, een terras en wijn/champagne wordt aangeboden aan de gasten. De unit heeft 1 bed.",
      "view": "Uitzicht op bergen, rivier, bezienswaardigheid, zwembad & tuin",
      "roomRules": "Roken: Niet roken. Stilte na 22:00 uur. Inchecken om 14:00 uur, Uitchecken om 12:00 uur."
    },
    "private-pool-villa-mountain-view": {
      "title": "Privézwembad Villa (Bergzicht)",
      "description": "Deze villa beschikt over een zwembad met uitzicht. Deze villa met airconditioning heeft een eigen ingang en bestaat uit 1 woonkamer, 1 aparte slaapkamer en 1 badkamer met een bad en een douche. De ruime villa beschikt over een minibar, een thee- en koffiezetapparaat, een zithoek en een terras met uitzicht op de tuin. De unit heeft 1 bed.",
      "view": "Uitzicht op tuin, zwembad, bergen & rivier",
      "roomRules": "Roken: Niet roken. Stilte na 22:00 uur. Inchecken om 14:00 uur, Uitchecken om 12:00 uur."
    },
    "features": {
      "Infinity Pool": "Overloopzwembad",
      "Mountain View": "Bergzicht",
      "Private Balcony": "Privébalkon",
      "Private Pool": "Privézwembad",
      "Mount Agung View": "Uitzicht op Mount Agung",
      "Living Room": "Woonkamer",
      "Nature View": "Natuurzicht",
      "Bedroom": "Slaapkamer"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "Dingen om te Doen",
      "title": "Creëer Uw Beste Herinneringen op Bali",
      "desc": "Van adembenemende natuuravonturen tot meeslepende culturele ervaringen, we presenteren een samengestelde selectie van activiteiten om elk moment van uw vakantie nog specialer te maken.",
      "btnScroll": "Bekijk Activiteiten"
    },
    "sidebar": {
      "categories": "Categorieën",
      "moreActivities": "Meer Activiteiten"
    },
    "categories": {
      "Adventure & Nature": "Avontuur & Natuur",
      "Culture & Art": "Cultuur & Kunst",
      "Wellness & Spiritual": "Wellness & Spiritualiteit"
    },
    "items": {
      "ATV Adventure": {
        "title": "ATV Avontuur",
        "description": "Ervaar de sensatie van het rijden op een ATV door de prachtige landschappen van Bali."
      },
      "Cycling Tour": {
        "title": "Fietstour",
        "description": "Fiets door weelderige rijstvelden en traditionele dorpjes tijdens een begeleide tour."
      },
      "Rice Terrace Walking Tour": {
        "title": "Rijstterras Wandeltour",
        "description": "Maak een rustige wandeling door enkele van de meest iconische rijstterrassen ter wereld."
      },
      "Sunrise Jeep Mount Batur": {
        "title": "Zonsopgang Jeep Mount Batur",
        "description": "Wees getuige van een adembenemende zonsopgang vanaf Mount Batur zonder de vroege ochtendwandeling."
      },
      "Scooter Tour": {
        "title": "Scootertour",
        "description": "Verken de verborgen juweeltjes van Sidemen tijdens een spannende begeleide scootertour."
      },
      "Rafting": {
        "title": "Rafting",
        "description": "Ervaar de adrenalinestoot van wildwatervaren op de Ayung-rivier."
      },
      "Batur Trekking": {
        "title": "Batur Trekking",
        "description": "Wandel de actieve vulkaan Mount Batur op en bekijk de zonsopgang vanaf de top."
      },
      "Waterfall Tour": {
        "title": "Watervaltour",
        "description": "Bezoek enkele van de mooiste en meest verborgen watervallen in de omgeving van Sidemen."
      },
      "Swing": {
        "title": "Schommelen",
        "description": "Ervaar de adrenaline van hoog boven de adembenemende valleien en jungles van Bali schommelen."
      },
      "Mount Agung Trekking": {
        "title": "Mount Agung Trekking",
        "description": "Daag jezelf uit met een lonende zonsopgangwandeling naar de hoogste top van Bali, Mount Agung."
      },
      "Cooking Class": {
        "title": "Kookles",
        "description": "Leer de geheimen van de authentieke Balinese keuken van onze deskundige lokale chef-koks."
      },
      "Silver Class": {
        "title": "Zilverles",
        "description": "Maak uw eigen unieke zilveren sieraden onder begeleiding van traditionele zilversmeden."
      },
      "Coffee Plantation Tour": {
        "title": "Koffieplantage Tour",
        "description": "Ontdek het proces van het maken van traditionele Balinese koffie, inclusief de beroemde Luwak-koffie."
      },
      "Yoga & Wellness": {
        "title": "Yoga & Wellness",
        "description": "Verjong uw geest en lichaam met onze begeleide yoga- en wellnesssessies."
      }
    }
  },
  "restaurant": {
    "categories": {
      "Appetizers": "Voorgerechten",
      "Soup": "Soepen",
      "Pasta": "Pasta",
      "Main Course": "Hoofdgerechten",
      "Indonesian Food": "Indonesisch Eten",
      "Dessert": "Desserts",
      "Beverages": "Dranken"
    },
    "hero": {
      "subtitle": "Bladerbos Restaurant",
      "title": "Een Zielrustgevende Culinaire Reis",
      "desc": "Geniet van voortreffelijke culinaire creaties die het lichaam voeden, vergezeld van het majestueuze panorama van Mount Agung...",
      "btnScroll": "Bekijk Menu"
    },
    "sidebar": {
      "categories": "Categorieën",
      "moreCategories": "Meer Categorieën"
    },
    "backToHome": "Terug naar Home"
  },
  "spa": {
    "categories": {
      "Body Massage": "Lichaamsmassage",
      "Specialty Treatments": "Speciale Behandelingen",
      "Body Scrub and Mask": "Lichaamsscrub en Masker",
      "Facial Treatment": "Gezichtsbehandeling",
      "Manicure and Pedicure": "Manicure en Pedicure",
      "Spa Packages": "Spa Arrangementen"
    },
    "hero": {
      "subtitle": "Welkom bij Patal Kikian Spa",
      "title": "Waar het Lichaam Rust, Keert de Ziel Terug",
      "desc": "Onze spa zorgt voor uw vermoeide lichaam, terwijl de weelderige natuur van Sidemen uw hart omhelst...",
      "btnScroll": "Bekijk Spa Menu"
    },
    "sidebar": {
      "treatments": "Behandelingen",
      "moreTreatments": "Meer Behandelingen"
    },
    "backToHome": "Terug naar Home"
  },
  "contact": {
    "hero": {
      "subtitle": "Neem contact op",
      "title": "Contact",
      "desc": "Wij zijn hier om u te helpen.",
      "scroll": "Contact"
    },
    "info": {
      "title": "Informatie",
      "desc": "Heeft u een vraag of hulp nodig?",
      "address": "Jl. Raya Sidemen, Sinduwati, Bali 80864"
    },
    "form": {
      "title": "Stuur een bericht",
      "name": "Uw Naam",
      "email": "Uw Email",
      "subject": "Onderwerp",
      "message": "Bericht",
      "btnSend": "Bericht Verzenden",
      "btnSending": "Verzenden...",
      "success": "Bedankt! Uw bericht is verzonden.",
      "error": "Oeps! Er ging iets mis."
    }
  },
  "faq": {
    "q1": {
      "question": "Hoe laat is de check-in en check-out?",
      "answer": "De inchecktijd is om 14:00 uur en de uitchecktijd is om 12:00 uur ('s middags). Vroeg inchecken of laat uitchecken is afhankelijk van beschikbaarheid en kan extra kosten met zich meebrengen."
    },
    "q2": {
      "question": "Is het ontbijt inbegrepen in de kamerprijs?",
      "answer": "Ja, een gratis dagelijks ontbijt is inbegrepen bij al onze villaboekingen."
    },
    "q3": {
      "question": "Bieden jullie luchthaventransfers aan?",
      "answer": "Ja, wij bieden luchthaventransfers aan tegen een extra vergoeding. Neem vooraf contact met ons op om uw ophaalservice te regelen."
    },
    "q4": {
      "question": "Is Patal Kikian gezinsvriendelijk?",
      "answer": "Hoewel we gasten van alle leeftijden verwelkomen, is ons eigendom ontworpen als een rustig toevluchtsoord. Ouders moeten te allen tijde toezicht houden op kinderen, vooral in de buurt van het zwembad."
    },
    "q5": {
      "question": "Houden jullie rekening met dieetbeperkingen?",
      "answer": "Absoluut. Ons restaurant kan tegemoetkomen aan verschillende dieetwensen, waaronder vegetarische, veganistische en glutenvrije opties. Informeer ons voor uw komst over uw wensen."
    },
    "q6": {
      "question": "Is er Wi-Fi beschikbaar in de villa?",
      "answer": "Ja, gratis snelle Wi-Fi is beschikbaar in het hele pand, inclusief alle kamers en openbare ruimtes."
    },
    "subtitle": "Informatie",
    "title": "Veelgestelde Vragen",
    "stillHaveQuestions": "Nog vragen?",
    "btnContact": "Contact"
  },
  "terms": {
    "usage": {
      "title": "Gebruik van de website",
      "p1": "Welkom op onze website. Als u deze website blijft gebruiken, gaat u ermee akkoord zich te houden aan de volgende gebruiksvoorwaarden, die samen met ons privacybeleid de relatie van Patal Kikian Villas met u regelen.",
      "p2": "Als u het niet eens bent met deze voorwaarden, gebruik onze website dan niet.",
      "p3": "De inhoud van de pagina's van deze website is alleen voor uw algemene informatie en gebruik."
    },
    "booking": {
      "title": "Boekingsvoorwaarden",
      "p1_bold": "Uw contract met Patal Kikian Villas:",
      "p1": "Deze Boekingsvoorwaarden vormen de basis van uw contract met Patal Kikian Villas. Door een boeking te maken, gaat de eerste genoemde persoon ermee akkoord gebonden te zijn aan deze voorwaarden.",
      "p2_bold": "Betaling:",
      "p2": "Bij boeking dient u geldige creditcardgegevens te verstrekken of een aanbetaling te doen. No-shows worden in rekening gebracht op de creditcard.",
      "p3_bold": "Nauwkeurigheid:",
      "p3": "We streven ernaar om ervoor te zorgen dat alle informatie accuraat is, maar we behouden ons het recht voor om fouten te corrigeren."
    },
    "cancellation": {
      "title": "Annuleringsbeleid",
      "p1_bold": "Standaardtarieven:",
      "p1": "Bij annulering binnen 14 dagen voor aankomst wordt één nacht in rekening gebracht. Bij annulering binnen 7 dagen, of in geval van een no-show, wordt 100% in rekening gebracht.",
      "p2_bold": "Niet-restitueerbare tarieven:",
      "p2": "Boekingen tegen niet-restitueerbare tarieven kunnen niet worden gewijzigd zonder 100% kosten."
    },
    "copyright": {
      "title": "Auteursrecht",
      "p1": "Deze website en de inhoud ervan zijn copyright van Patal Kikian Villas. Alle rechten voorbehouden."
    },
    "subtitle": "Legaal",
    "title": "Algemene Voorwaarden"
  },
  "privacy": {
    "policy": {
      "title": "Privacybeleid",
      "p1": "Wij begrijpen dat het verstrekken van persoonlijke informatie veel vertrouwen vergt; we nemen dit vertrouwen zeer serieus. Dit beleid beschrijft hoe we uw informatie beschermen.",
      "p2": "Wij doen er alles aan om ervoor te zorgen dat uw privacy wordt beschermd.",
      "p3": "We kunnen dit beleid van tijd tot tijd wijzigen door deze pagina bij te werken."
    },
    "collect": {
      "title": "Wat we verzamelen",
      "p1": "We kunnen de volgende informatie verzamelen:",
      "l1": "Naam en contactgegevens",
      "l2": "Demografische informatie",
      "l3": "Andere relevante informatie",
      "l4": "Uw IP-adres"
    },
    "usage": {
      "title": "Wat we doen met de informatie",
      "p1": "We hebben deze informatie nodig om u een betere service te bieden:",
      "l1": "Interne administratie.",
      "l2": "Om onze producten te verbeteren.",
      "l3": "Om promotionele e-mails te sturen.",
      "l4": "Om de website aan te passen.",
      "p2": "U kunt zich afmelden via info@patalkikianbali.com."
    },
    "security": {
      "title": "Veiligheid",
      "p1": "We doen er alles aan om ervoor te zorgen dat uw informatie veilig is.",
      "p2_bold": "Financiële informatie:",
      "p2": "We slaan geen creditcardgegevens op onze lokale servers op."
    },
    "cookies": {
      "title": "Hoe we cookies gebruiken",
      "p1": "Cookies helpen ons webverkeer te analyseren. U kunt ervoor kiezen om cookies te accepteren of te weigeren."
    },
    "subtitle": "Legaal",
    "title": "Privacybeleid"
  },
  "footer": {
    "explore": "Ontdekken",
    "information": "Informatie",
    "desc": "Ervaar het serene leven in Sidemen. Geniet van de spectaculaire Mount Agung, luxe villa's en warme gastvrijheid.",
    "translate": "Vertalen",
    "quickLinks": "Snelle Links",
    "support": "Ondersteuning",
    "contactTitle": "Contact",
    "contact": "Contact",
    "faq": "FAQ",
    "terms": "Algemene Voorwaarden",
    "privacy": "Privacybeleid",
    "whatsappUs": "WhatsApp Ons",
    "allRightsReserved": "Alle rechten voorbehouden.",
    "newsJournal": "Nieuws & Journaal"
  },
  "news": {
    "journal": "Journaal",
    "latest": "Laatste Nieuws & Verhalen",
    "subtitle": "Blijf op de hoogte van het laatste nieuws, verhalen en evenementen rond Patal Kikian en Sidemen.",
    "readNews": "Lees Nieuws",
    "allArticles": "Alle Artikelen",
    "noArticles": "Geen artikelen gevonden in deze categorie.",
    "page": "Pagina",
    "of": "van"
  },
  "newsSearch": {
    "searchBreadcrumb": "Zoeken",
    "searchResults": "Zoekresultaten",
    "searchArticles": "Zoek Artikelen",
    "resultsFound": "{{count}} resultaten gevonden",
    "forQuery": " voor \"{{query}}\"",
    "placeholder": "Zoek artikelen...",
    "searchBtn": "Zoeken",
    "noResults": "Geen artikelen gevonden voor \"{{query}}\".",
    "enterKeyword": "Voer een trefwoord in om te zoeken.",
    "backToNews": "Terug naar Nieuws"
  },
  "newsCategory": {
    "category": "Categorie",
    "articlesInCat": "artikelen in deze categorie",
    "noArticles": "Geen artikelen gevonden in deze categorie.",
    "backToNews": "Terug naar Nieuws"
  },
  "newsDetail": {
    "tags": "Tags",
    "exclusiveStay": "Exclusief Verblijf",
    "promoDesc": "Ervaar Premium Luxe in Sidemen",
    "bookStay": "Boek Uw Verblijf",
    "reserveStay": "Reserveer Uw Verblijf",
    "villaRecs": "Villa Aanbevelingen",
    "recAccommodations": "Aanbevolen Accommodaties",
    "readArticle": "Lees Artikel",
    "search": "Zoeken",
    "searchPlaceholder": "Zoek artikelen...",
    "go": "Gaan",
    "categories": "Categorieën",
    "popularPosts": "Populaire Artikelen",
    "bookNow": "Nu Boeken",
    "notFound": "Artikel Niet Gevonden",
    "notFoundDesc": "Het artikel dat u zoekt bestaat niet of is verplaatst.",
    "backToNews": "Terug naar Nieuws"
  }
}